<!-- 衍生资料模板库 / 新品 免检 SQM -->
<template>
  <h-list-page class="TemplateLibraryDerivativeMaterials_style">
    <!-- 搜索条件 -->
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <!-- 样检单号 -->
        <h-search :title="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search>
        <!-- 专用号 -->
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <!-- 请输入至少四位专用号 -->
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.mtlNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.mtlNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <!-- 物料号 -->
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <!-- 物料名称 -->
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>

        <!-- 互联工厂 -->
        <h-search :title="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')">
          <h-input v-model="searchData.sybName" clearable></h-input>
        </h-search>

        <!-- 资料库状态 -->
        <h-search :title="h_i18n('ed158b5b8cf3beebc4e770762ad0cdd2')">
          <!-- 请选择 -->
          <h-select v-model="searchData.selfCheckState" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" multiple style="width: 196px" clearable filterable class="myMultiple90">
            <h-option v-for="item in fileStatus" :label="item.label" :value="item.value" :key="item.value"></h-option>
            
            <!-- <h-option label="自检待上传" value="2226"></h-option>
            <h-option label="自检待审核" value="2227"></h-option>
            <h-option label="自检审核驳回" value="2228"></h-option>
            <h-option label="自检待校核" value="2229"></h-option>
            <h-option label="自检合格" value="2230"></h-option>
            <h-option label="自检不合格" value="2236"></h-option> -->
            <!-- <h-option label="自检批准驳回" value="2249"></h-option> -->
            <!-- <h-option label="有效期内合格" value="2247"></h-option> -->
          </h-select>
        </h-search>

        <!-- 制版设计稿状态 -->
        <h-search :title="h_i18n('bc8fe2d1e2a6424c7a88234c68e32db1')">
          <!-- 请选择 -->
          <h-select v-model="searchData.pictureCheckState" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" multiple style="width: 196px" clearable filterable class="myMultiple115">
            <h-option v-for="item in pictureStatusList" :label="item.label" :value="item.value" :key="item.value"></h-option>
            <!-- <h-option label="待上传" value="1432"></h-option>
            <h-option label="待审核" value="1433"></h-option>
            <h-option label="型号经理审核打回" value="1434"></h-option>
            <h-option label="型号经理审核通过" value="1435"></h-option> -->
          </h-select>
        </h-search>

        <!-- 日期 -->
        <h-search :title="h_i18n('4ff1e74e43a3586339251494117185ad')">
          <!-- 开始；结束 -->
          <h-date-picker @change="TimeChange(searchData.date,{start:'sendDayStart',end:'sendDayEnd'})" v-model="searchData.date" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="searchLoading" @click="getInfo(true)">
            <template #icon>
              <search/>
            <!-- 查询 -->
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <h-table-card title="衍生资料模板库" :is-left="0" :h-data="dataOfTable">
        <!-- 请点击“查询”数据 -->
        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="tableLoading" height="540" @selection-change="listCheckBoxChange"
        border :data="dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <!-- 样检单号 -->
        <el-table-column prop="patternPlanId" :label="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')" width="230"></el-table-column>
        <!-- 日期 -->
        <el-table-column prop="sendDay" :label="h_i18n('4ff1e74e43a3586339251494117185ad')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.sendDay) }}</span>
          </template>
        </el-table-column>
        <!-- 专用号 -->
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="120"></el-table-column>
        <!-- 物料名称 -->
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" min-width="200"></el-table-column>
        <!-- 互联工厂 -->
        <el-table-column prop="sybName" :label="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')" min-width="130"></el-table-column>
        <!-- 模块类别 -->
        <el-table-column prop="materielCategoryName" :label="h_i18n('8e808f51e7025756613a867dee579ab3')" min-width="120"></el-table-column>
        <!-- 资料库状态 -->
        <el-table-column prop="" :label="h_i18n('ed158b5b8cf3beebc4e770762ad0cdd2')" min-width="120">
          <template #default="{ row }">
            <span class="successColor" v-if="row.selfCheckState == '2247'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="warningColor plan_a_a" v-if="row.selfCheckState=='2227'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="warningColor plan_a_a" v-if="row.selfCheckState=='2229'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="dangerColor" v-if="row.selfCheckState=='2228'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span v-if="row.selfCheckState=='2226'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="successColor" v-if="row.selfCheckState=='2230'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="dangerColor" v-if="row.selfCheckState=='2249'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="dangerColor" v-if="row.selfCheckState=='2236'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
            <span class="dangerColor" v-if="row.selfCheckState=='2501'">
              {{ selfCheckStatus[row.selfCheckState] }}
            </span>
          </template>
        </el-table-column>
        <!-- 资料库文件 -->
        <el-table-column prop="" :label="h_i18n('58e34bb503890b10f69243b88dbf8557')" min-width="100" v-if="roleCode == 'S009' || roleCode == 'S003'">
          <template #default="{ row }">
            <!-- 上传 -->
            <span v-if="row.templetDocumentState != 'Y' && (row.selfCheckState=='2226'||row.selfCheckState=='2249' ||row.selfCheckState == '2228')"
            style="color:#2164f5;cursor: pointer;" @click="openTempUp(row)">{{ h_i18n('d5a73b0c7f2f052a5da435ca7072362c') }}</span>
            <span v-else style="color:#2164f5;cursor: pointer;" @click="lookTempUp(row)">
              <!-- 查看 -->
              <span v-show="row.templetId">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 设计稿状态 -->
        <el-table-column prop="pictureCheckState" :label="h_i18n('cfdab880d0419e67bde0b21ea84f192f')" min-width="100">
          <template #default="{ row }">
            <span v-if="row.pictureCheckState == '1432'">{{ pictureCheckStatus[row.pictureCheckState] }}</span>
            <span v-if="row.pictureCheckState == '1433'" class="warningColor" style="cursor:pointer" @click="openPictureDetail(row)">{{ pictureCheckStatus[row.pictureCheckState] }}</span>
            <span v-if="row.pictureCheckState == '1434'" class="dangerColor" style="cursor:pointer" @click="openPictureDetail(row)">{{ pictureCheckStatus[row.pictureCheckState] }}</span>
            <span v-if="row.pictureCheckState == '1435'" class="successColor" style="cursor:pointer" @click="openPictureDetail(row)">{{ pictureCheckStatus[row.pictureCheckState] }}</span>
          </template>
        </el-table-column>
        <!-- 制版设计稿 -->
        <el-table-column prop="" :label="h_i18n('2f4fd79b3f9b4a273afa62295ab7db6a')" min-width="100" v-if="roleCode == 'S009' || roleCode == 'S003'">
          <template #default="{ row }">
            <!-- 上传 -->
            <span v-if="row.pictureCheckState=='1432'||row.pictureCheckState=='1434'"
            style="color:#2164f5;cursor: pointer;" @click="openPictureUp(row)">{{ h_i18n('d5a73b0c7f2f052a5da435ca7072362c') }}<!-- patternPlanId  -->
            </span>
            <span v-else-if="row.pictureCheckState=='1433'||row.pictureCheckState=='1435'">
              <!-- 已上传 -->
              <span v-show="row.templetId">{{ h_i18n('ba7f57c5e8c8c5ee90b04380eb85fb54') }}</span>
            </span>
            <span v-else></span>
          </template>
        </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
          v-model:currentPage="searchData.pageIndex" :page-size="10" layout="total, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
    </h-table-card> 

    <!-- 模板库资料上传；模板库资料查看 -->
    <h-dialog :show="templetShowFlag" :title="TempletBtnFlag ? h_i18n('c2620c9a894b90f916e967f938fee9f3') : h_i18n('6f8671d19993689a8ca83bc0eca7cf91')" footer @close="dialogClose" width="70%"
      class="tempUp_dialog_style">
        <!-- 模板库资料 -->
        <form-header :title="h_i18n('5224dc5b23899579541c61008a2b0f59')" title-height="80px" style="margin-top:8px;" v-loading="templetLoading">
          <template #body>
            <!-- 模板库属性 -->
            <h-tr>{{ h_i18n('eda1ed64d0b056b855397956d73f02c4') }}</h-tr>
            <tr v-if="getData.model.queryFlag == 'film'">
              <!-- 大类；盘膜 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('e86da95db59395cf9770af483fde29b5') }}</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
              <!-- 胶型 -->
              <report-td :title="h_i18n('5f84a2040ec3476882e06ed9baec08e3')" colspan="4:4">{{ getData.model.glue }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'film' && !TempletBtnFlag">
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:20">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'instruc'">
              <!-- 大类；说明书 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('1f08ac8f42c807aa697b5c721dd69165') }}</report-td>
              <!-- 颜色 -->
              <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.colorOne }}</report-td>
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'pop'">
              <!-- 大类 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">POP</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.typeOne }}</report-td>
               <!-- 模板库ID -->
                <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'sticker'">
              <!-- 大类；不干胶贴 -->
              <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('cc14f91613bf7e8f816ff7a6a825e1c2') }}</report-td>
              <!-- 材质 -->
              <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
              <!-- 颜色 -->
              <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" colspan="4:4">{{ getData.model.color }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'sticker'">
              <!-- 工艺 -->
              <report-td :title="h_i18n('ec9875c10f408999de612355983da20c')" colspan="4:4">{{ getData.model.technology }}</report-td>
              <!-- 用途 -->
              <report-td :title="h_i18n('9c5d49bda7000887a8d10670ef1b1ed7')" :colspan="TempletBtnFlag ? '4:12' : '4:4'">{{ getData.model.bakOne }}</report-td>
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:4">{{ getData.templetId }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <!-- 类别 -->
              <report-td :title="h_i18n('383a6d166f8f60e16e726ccc9c483631')" colspan="4:4">{{ getData.model.category }}</report-td>
              <!-- 瓦楞类型 -->
              <report-td :title="h_i18n('B93E049754A3CA6A8FA1F4CF986A53FB')" colspan="4:4">{{ getData.model.fluteType }}</report-td>
              <!-- <report-td :title="h_i18n('D6DB2072CBCC214F4D1FAFF6E58C78E8')" colspan="4:4">{{ getData.model.internalLength }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <report-td :title="h_i18n('D84B4767A7C8B781D735629880862BC2')" colspan="4:4">{{ getData.model.internalHeight }}</report-td>
              <report-td :title="h_i18n('93D61B5D9249964403EABBF6D94E113B')" colspan="4:4">{{ getData.model.internalWidth }}</report-td> -->
              <!-- 规格 -->
              <report-td :title="h_i18n('ea887bd098de889dff3208a64d2b67e3')" colspan="4:4">{{ getData.model.specification }}</report-td>
            </tr>
            <tr v-if="getData.model.queryFlag == 'carton'">
              <!-- 纸箱结构 -->
              <report-td :title="h_i18n('1042E7C4E324DA82D65177C4D247AA22')" :colspan="TempletBtnFlag ? '4:20' : '4:4'">{{ getData.model.cartonStructure }}</report-td>
              <!-- 模板库ID -->
              <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" v-if="!TempletBtnFlag" colspan="4:12">{{ getData.templetId }}</report-td>
            </tr>
            <!-- 模板库项目 -->
            <h-tr>{{ h_i18n('5c1fdc0499d6971eb7111b473f98e6d6') }}</h-tr>
            <tr class="info_table_style">
              <!-- 序号 -->
              <td colspan="2">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</td>
              <td colspan="2">*</td>
              <!-- 项目 -->
              <td colspan="6">{{ h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a') }}</td>
              <!-- 附件 -->
              <td colspan="12">{{ h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c') }}</td>
              <!-- 结论 -->
              <td colspan="2">{{ h_i18n('54bbba803f13eaab0f5441d97b13247a') }}</td>
            </tr>
            <template v-for="(item,index) in documentList" :key="item.documentId">
              <tr class="info_table_body_style">
                <td colspan="2">{{ index + 1}}</td>
                <td colspan="2">
                  <span v-if="item.isNeed == 'Y'" class="dangerColor">*</span>
                </td>
                <td colspan="6">
                  <span>{{ item.documentName }}</span>
                </td>
                <td colspan="12">
                  <hc-file-upload v-if="TempletBtnFlag && tempFileUp" :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" v-model="tempFile[index]" :disabled="disabledFlag"
                    delete download @change="fileUpChange($event,item,index)" @delete="deleteFile(index,item)" @error="error" @download="downLoadFile(item.fileId,item.fileName)">
                  </hc-file-upload>
                  <span v-else @click="downLoadFile(item.fileId,item.fileName)"
                    style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block">
                    {{ item.fileName }}
                  </span>
                </td>
                <td colspan="2">
                  <!-- 不合格 -->
                  <span class="dangerColor" v-if="item.conclusion === 'F'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                  <!-- 合格 -->
                  <span v-else>{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                  <!-- <el-select v-model="item.conclusion" @change="changeFun($event,item)">
                    <el-option value="P" label="P"></el-option>
                    <el-option value="F" label="F"></el-option>
                  </el-select> -->
                </td>
              </tr>
            </template>
            <tr v-if="getData.patternPlan.selfCheckState == 2228">
              <!-- 打回备注 -->
              <report-td :title="h_i18n('c811b6a0427ea764d9cf1c52bff7d0aa')" colspan="4:20">{{ getData.patternPlan.supplyCheckMark }}</report-td>
            </tr>
          </template>
        </form-header>
        <template #footer>
            <h-button-group align="center">
              <!-- 保存 -->
              <h-button type="primary" v-if="TempletBtnFlag" @click="saveBtn()" :loading="saveLoading" :disabled="saveBtnDisabled">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
              <!-- 返回 -->
              <h-button type="primary" v-else @click="dialogClose()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
            </h-button-group>
        </template>
    </h-dialog>
    <!-- 制版设计稿上传 -->
    <h-dialog :show="pictureShowFlag" :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" footer @close="dialogClose" width="70%"
      class="picUp_dialog_style">
      <!-- 制版设计稿上传 -->
      <form-header :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" title-height="80px" style="margin-top:8px;" v-loading="templetLoading">
        <template #body>
          <tr>
            <!-- 制版设计稿上传 -->
            <report-td :title="h_i18n('65d2b4cc69ee0d7fa8706a074b5b2b39')" colspan="4:20">
              <hc-file-upload :info="h_i18n('a14efa27c74b8de344fb306f9e2bc3bc')" v-model="tempFile[101]" size="50"
                delete download @change="fileUpChange($event,rowData,101)" @delete="deleteFile(101,rowData)" @error="error" @download="downLoadFile(pictureFileId,pictureFileName)">
              </hc-file-upload>
            </report-td>
          </tr>
        </template>
      </form-header>
      <template #footer>
            <h-button-group align="center">
              <!-- 保存 -->
              <h-button type="primary" @click="saveBtnP()" :loading="saveLoading">{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
            </h-button-group>
        </template>
    </h-dialog>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import hDialog from '../../../views/Templates/h-dialog.vue';
import axios from "axios";
export default {
  components: { hDialog },

  data(){
    return{
      saveBtnDisabled:false, // 是否禁用模板保存按钮
      tempFileUp: false,// 是否能上传模板
      // selfCheckStatus:{'2227':'自检待审核','2229':'自检待校核','2228':'自检审核驳回','2226':'自检待上传',
      //    '2230':'自检合格','2249':'自检批准驳回',"2236":'自检不合格',"2244":'有效期内合格'},
      // pictureCheckStatus:{'1432':'待上传','1433':'待审核','1434':'审核打回','1435':'审核通过'},
      selfCheckStatus:{},
      pictureCheckStatus:{},
      searchData:{
        pageIndex: 1,
        mtlNo:'',
      },
      dataOfTable:[],
      tableLoading:false,
      searchLoading:false,
      plan:{
        showMtlPlan:false,
      },
      loading:{
        mtlLoading:false,
      },
      templetShowFlag:false,
      getData:{
        model:{},
        patternPlan:{}
      },
      templetLoading:false,
      pictureShowFlag:false,
      saveLoading:false,
      tempFile:[],
      rowData:null,
      total:0,
      documentList:[],
      TempletBtnFlag:false,
      templetFlag:false,
      http: {
        mtlSearchHttp: null,//专用号模糊查询
      },
      supplyList:["V14419", "V14252", "V12999", "V13026", "V13336", "V14353", "V14318", "V14199", "V12858", "V13794", "V14011", "V13093", "V12437", "V12295", "V14182", "V14326", "V67251", "V54260", "V14513", "V14531", "V14434", "V14463", "V14579", "V14811",
        "V14644","V14837","V13841","V14559","V14092","V14681","V14950","V14833","V15142"],
      disabledFlag:false,
      fileStatus:[],
      pictureStatusList:[],
    }
  },
  methods:{
    h_i18n,
    changeMethod() {
      this.postThisPageHeight()
    },
    // 时间范围选择
    TimeChange (date, {start,end}) {
      if (date) {
        this.searchData[start] = this.time(date[0]);
        this.searchData[end] = this.time(date[1]);
      } else {
        this.searchData[start] = undefined;
        this.searchData[end] = undefined;
      }
    },
    saveBtn(){
      if(!this.documentList.every(item=> item.isNeed != 'Y' || item.isNeed == 'Y' && item.fileId && item.fileName)){
        // 有必传项附件未上传！
        this.info(h_i18n('44fa23d8664edf3f7af6178d95cc7c34'))
        return
      }
      this.saveLoading = true
      this.$http({
        method:'post',
        url:'/base/newProductTemplet/saveSqmTempletDocument',
        data:{
          fixConfig:true,
          supplyCode:this.supplyCode,
          patternPlanId:this.rowData.patternPlanId,
          templetId:this.rowData.templetId,
          documentList:this.documentList,
          submitMan:this.trueName,
        }
      }).then(res=>{
        if(res.data.code == 200){
          // 成功
          this.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.dialogClose()
              this.getInfo()
            }
          })
        }else{
          this.info(res.data.msg)
        }
      }).catch(err=>{
        this.info(err)
      }).finally(()=>{
        this.saveLoading = false
      })
    },
    saveBtnP(){
      if(!this.pictureFileId || !this.pictureFileName){
        // 制版设计稿未上传！
        this.info(h_i18n('199f4ae28e2c114a0c5368e74d579d5b'))
        return
      }
      this.saveLoading = true
      this.$http({
        method:'post',
        url:'/base/newProductTemplet/insertPictrue',
        data:{
          fixConfig:true,
          pictureFileId:this.pictureFileId,
          pictureFileName:this.pictureFileName,
          patternPlanId:this.rowData.patternPlanId,
          pictureSubmitMan:this.$route.query.trueName || this.$route.query.userName || this.$route.query.nickName,
        }
      }).then(res=>{
        if(res.data.code == 200){
          // 成功
          this.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.dialogClose()
              this.getInfo()
            }
          })
        }else{
          this.warning(res.data.msg)
        }
      }).catch(err=>{
        this.info(err)
      }).finally(()=>{
        this.saveLoading = false
      })
    },
    // 资料库 查看
    lookTempUp(row) {
      this.TempletBtnFlag = false
      this.templetShowFlag = true 
      this.rowData = row
      this.disabledFlag = true
      this.hasTempInfo(row)
      this.postThisPageHeight()
    },
    openTempUp(row) {
      this.TempletBtnFlag = true
      this.templetShowFlag = true 
      this.rowData = row
      if(row.selfCheckState=='2249' ||row.selfCheckState == '2228'){
        this.hasTempInfo(row)
      }else{
        this.getTempInfo(row)
      }
      this.postThisPageHeight()
    },
    // 设计稿
    lookPictureUp(row){
      if(!row.pictureFileId){
        // 暂无制版设计稿数据！
        this.info(h_i18n('fbddd51d87a9b798193bda360b4ef671'))
        return
      }
      this.downLoadFile(row.pictureFileId,row.pictureFileName)
    },
    openPictureUp(row){
      this.pictureShowFlag = true 
      this.rowData = row
      if(row.pictureFileName){
        // this.tempFile[101]={name:row.pictureFileName}
      }
      this.postThisPageHeight()
    },
    openPictureDetail(row){
      this.$router.push({
        name:'PictureDetail',
        query: {
            patternPlanId:row.patternPlanId,
            data: JSON.stringify(row),
            dataFrom:'sqm'
          }
      })
    },
    dialogClose() {
      this.pictureShowFlag = false
      this.templetShowFlag = false
      this.rowData = null
      this.tempFile = []
      this.pictureFileId = null
      this.pictureFileName = null
      this.documentList = []
      this.disabledFlag = false
    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
     myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    getTempInfo(row){
      let templetId = row.templetId 
      if(!templetId){
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
      }else{
        let thetype = 'T'
        if(row.selfCheckState == '2230' || row.selfCheckState == '2247'){
          thetype = 'Y'
        }else if(row.selfCheckState == '2236'){
          thetype = 'N'
        }
        if(this.TempletBtnFlag){
          this.$http({
            method:'get',
            url:`/base/newProductTemplet/getSqmTempletDocumentBySupplyCode?supplyCode=${this.supplyCode}&templetId=${templetId}`
          }).then(res=>{
             /**
             * 2025年8月1日
             * 200不提示，300和500提示
                200是成功，可以上传文件，可以保存；
                300是成功，不可以上传文件，可以保存；
                500是失败，禁止上传文件和保存；
             */
            if(res.data.code === '200'){
              this.tempFileUp = true
              this.saveBtnDisabled = false
            }else if(res.data.code === '300'){
              this.tempFileUp = false
              this.saveBtnDisabled = false
              res.data.msg && this.info(res.data.msg)
            }else{
              this.tempFileUp = false
              this.saveBtnDisabled = true
              this.info(res.data.msg)
            }
          }).catch(err=>{
            
          }).finally(()=>{
  
          })
        }
        this.templetLoading = true
        this.$http({
        method:'get',
        url:'/base/newProductTemplet/getSqmTempletDocument?templetId='+templetId +'&supplyCode='+this.supplyCode+"&type="+thetype+"&patternPlanId="+row.patternPlanId,
      }).then(res=>{
        if(res.data.code == 200 && res.data.msg == '成功'){
          this.getData = res.data.data
          res.data.data.documentList.forEach((item,index)=>{
            // console.log(item)
            this.documentList.push(item)
            if(item.fileName) {this.tempFile[index]={name:item.fileName}}
          })
        }else{
          this.templetShowFlag = false
          // 数据查询错误！
          this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        }
      }).catch(err=>{
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        console.log(err)
      }).finally(()=>{
        this.templetLoading = false
      })
      }
    },
    hasTempInfo(row){
      let templetId = row.templetId 
      if(!templetId){
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
      }else{
        this.templetLoading = true
        let thetype = 'T'
        if(row.selfCheckState == '2230' || row.selfCheckState == '2247'){
          thetype = 'Y'
        }else if(row.selfCheckState == '2236'){
          thetype = 'N'
        }
        if(this.TempletBtnFlag){
          this.$http({
            method:'get',
            url:`/base/newProductTemplet/getSqmTempletDocumentBySupplyCode?supplyCode=${this.supplyCode}&templetId=${templetId}`
          }).then(res=>{
            /**
             * 2025年8月1日
             * 200不提示，300和500提示
                200是成功，可以上传文件，可以保存；
                300是成功，不可以上传文件，可以保存；
                500是失败，禁止上传文件和保存；
             */
            if(res.data.code === '200'){
              this.tempFileUp = true
              this.saveBtnDisabled = false
            }else if(res.data.code === '300'){
              this.tempFileUp = false
              this.saveBtnDisabled = false
              res.data.msg && this.info(res.data.msg)
            }else{
              this.tempFileUp = false
              this.saveBtnDisabled = true
              this.info(res.data.msg)
            }
          }).catch(err=>{
            
          }).finally(()=>{
  
          })
        }
        this.$http({
        method:'get',
        url:'/base/newProductTemplet/getSqmTempletDocument?templetId='+templetId +'&supplyCode='+this.supplyCode+"&type="+thetype+"&patternPlanId="+row.patternPlanId,
      }).then(res=>{
        if(res.data.code == 200 && res.data.msg == '成功'){
          this.getData = res.data.data
          res.data.data.documentList.forEach((item,index)=>{
            // console.log(item)
            this.documentList.push(item)
            if(item.fileName) {this.tempFile[index]={name:item.fileName}}
          })
        }else{
          this.templetShowFlag = false
          // 数据查询错误！
          this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        }
      }).catch(err=>{
        this.templetShowFlag = false
        // 数据查询错误！
        this.info(h_i18n('a5473898b0523299c9d8b8f715693a6c'))
        console.log(err)
      }).finally(()=>{
        this.templetLoading = false
      })
      }
    },
    getInfo(flag){
      if (true == flag) {
        this.searchData.pageIndex = 1;
      }
      this.tableLoading = true
      this.$http({
        method:'post',
        url:'/base/patternPlan/listPage',
        data:{
          fixConfig:true,
          ...this.searchData,
          pageSize:10,
          date:undefined,
          userId: "SUPPLY",
          isTemplet:'Y',
          pictureCheckState:this.searchData.pictureCheckState.length > 0 ? this.searchData.pictureCheckState : undefined,
          selfCheckState:this.searchData.selfCheckState.length > 0 ? this.searchData.selfCheckState : undefined,
        }
      }).then(res=>{
        if(res.data.code == 200 && res.data.msg == '成功'){
          this.dataOfTable = res.data.data.records
          this.total = res.data.data.total
        }
      }).catch(err=>{

      }).finally(()=>{
        this.tableLoading = false
      })
    },
    // 附件
    downLoadFile (uuid,name) {
      if(!uuid){
        return
      }
      this.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
      let url = '/base/fileDownload/downloadFile?filePath=' + uuid
      if(uuid && uuid.includes("http")){
          url = '/base/fileDownload/downloadFile?filePath=' + uuid.split('sqm.haier.net/readFile/')[1]
      }else if(uuid.includes("mkhl/bukl/")){
          url = '/base/fileDownload/downloadFile?filePath=' + uuid
      }else {
          url = '/base/fileDownload/downloadFile?filePath=hmqm/reject/' + uuid
      }    
      this.httpFile(
        {
          method: 'get',
          url: url,
          headers: { 'content-type': 'application/json' }
        },
        name
      );
    },
    fileUpChange  (options,item,index) {
      let formData = new FormData();
      formData.append('files', options.file);
      this.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
      this.$http({
          method: 'post',
          // url: '/base/fileUpload/uploadToOssSaveUrl',
          url: '/base/fileUpload/uploadToOss',
          headers: { 'Content-Type': 'multipart/form-data' },
          data: formData,
          cache: false,
          processData: false,
          contentType: false
        }).then((res) => {
          if(res.data.code == '0' && res.data.data){
            if(index == 101){
              this.pictureFileId = res.data.data
              this.pictureFileName = options.file.name
            }else{
              item.fileId = res.data.data;
              item.fileName = options.file.name;
            }
          }else{
            this.error(h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'))
            this.tempFile[index] = null
          }
        }).catch((err) => {
          this.error(h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'))
          this.tempFile[index] = null
        }).finally(()=>{
          this.closeLoading()
        })
    },
    deleteFile (index,item) {
      this.tempFile[index] = null
      item.fileId = null
      item.fileName = null
      this.pictureFileId = null
      this.pictureFileName = null
    },
    error (str) {
      this.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str, confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721') });
    },
    // 查询是否模板库供应商
    getTempletSupply(){
      // this.$http({
      //   url:'/base/basicData/baseValuesById?valueId=2209',
      //   method:'get'
      // }).then(res=>{
      //   // console.log(res.data.data.reamrk.length)
      //   if(res.data.data.reamrk){
      //       this.supplyList = res.data.data.reamrk.split(',')
      //       this.templetFlag = this.supplyList.includes(this.supplyCode.toUpperCase())
      //       if(!this.templetFlag){
      //         this.$router.back()
      //       }
      //     }
      // }).catch(err=>{})
      this.$http({
        method:'post',
        url:'/base/patternPlan/templateSupplierList',
        data:{
          pageNo:1,
          pageSize:9999,
        }
      }).then(res=>{
        if(res.data.code == '200' && res.data.data && res.data.data.records){
          this.supplyList = res.data.data.records.map(item=>{
            return item.supplyCode
          })
          this.templetFlag = this.supplyList.includes(this.supplyCode.toUpperCase())
        }
      }).catch(err=>{
      }).finally(()=>{
      })
    },
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [92,78],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            if(item.valueTypeId == 92){
              this.fileStatus.push({value:item.valueId,label:item.valueName})
              this.selfCheckStatus[item.valueId] = item.valueName
            }
            if(item.valueTypeId == 78){
              this.pictureStatusList.push({value:item.valueId,label:item.valueName})
              this.pictureCheckStatus[item.valueId] = item.valueName
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
  },
  mounted(){
    if(this.$route.query){
      this.searchData.supplyCode = this.supplyCode = this.$route.query.supplyCode
      this.searchData.supplyName = this.$route.query.supplyName
      this.roleCode = this.$route.query.roleCode
      this.trueName = this.$route.query.trueName || this.$route.query.userName || this.$route.query.nickName
      this.getTempletSupply()
    }
    this.getBaseValues()
    this.getInfo()
  }
}
</script>

<style lang="scss">
.TemplateLibraryDerivativeMaterials_style{
  .haier-dialog--body{
    padding: 0;
  }
  .info_table_style td {
       height:41px;
       font-size:14px;
       color:#666;
       border-bottom: 1px solid #ccc;
       border-right: 1px solid #ccc;
       text-align:center;
       background: #FAFAFA;
     
   }
   .info_table_body_style td {
     height:41px;
     font-size:14px;
     color:#666;
     border-bottom: 1px solid #ccc;
     border-right: 1px solid #ccc;
     text-align:center;
     white-space: nowrap;
     text-overflow: ellipsis;
     overflow: hidden;
     &:hover {
       white-space: normal;
       word-break: break-all;
     }
   }
   .tempUp_dialog_style{
     .haier-dialog{
       top:100px !important;
       .haier-table-header{
        display: none;
       }
    }
   }
   .picUp_dialog_style{
    .haier-dialog{
       top:100px;
       .haier-table-header{
        display: none;
       }
    }
   }
}
.planHidden {
  display: none;
}
.myMultiple90 .el-select__tags {
  padding-left: 90px;
  box-sizing: border-box;
}
.myMultiple115 .el-select__tags {
  padding-left: 115px;
  box-sizing: border-box;
}
</style>